import React from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import { Filler } from 'chart.js';
import { Line } from 'react-chartjs-2';
import NoData from './NoData';

const ObjectsAndDeviations = ({ type }) => {
  const {
    summedLoading,
    summed: { totNrOfObjects = [], totNrOfDeviations = [] },
  } = useSelector(state => state.compliance.objectsAndDeviations);

  const data =
    type === 'OBJECTS'
      ? totNrOfObjects.map(item => item?.nrOfObjects)
      : totNrOfDeviations.map(item => item?.nrOfDeviations);

  const quarters = Array.from({ length: data.length }, () => `${''}`);

  const chartData = {
    type: 'line',
    labels: quarters,
    datasets: [
      {
        data,
        borderColor: ColorsV2.acent,
        borderWidth: 2,
        pointRadius: 0,
        pointHitRadius: 20,
        tension: 0.3,
        backgroundColor: ColorsV2.outline,
        fill: 'start',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          color: ColorsV2.white,
        },
        grid: {
          display: false,
        },
      },
      y: {
        ticks: {
          color: ColorsV2.white,
          max: Math.max(data),
        },
        grid: {
          display: false,
        },
      },
    },
    animation: false,
    height: 300,
  };

  if (summedLoading) {
    return (
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
        <CircularProgress size='4rem' sx={{ color: ColorsV2.acent }} />
      </Box>
    );
  }

  return (
    <>
      {data?.length ? (
        <Line data={chartData} plugins={[Filler]} options={options} type='line' />
      ) : (
        <NoData />
      )}
    </>
  );
};

export default ObjectsAndDeviations;
